/* Initialize Api Module */
(function (API, app) {
	window.api = new API({
		serviceName: '/ApacService',
		handlersName: '/ApacHandlers',
		dialog: function (msg) {
			app.dialog.error({ title: '', message: '<div class="notifier-message__icon"><div class="warning-icon"></div>' + msg + '</div>' });
		},
		userGroup: app.GlobalSettings.ug || '',
		errorPopupMethod: function () { app.dialog.popup({ title: PageTemplates.get('GeneralTechnicalDifficulties') }); },
		waitDialog: {
			dialog: null,
			start: function () {
				this.dialog = app.dialog.wait();
			},
			stop: function () {
                this.dialog && this.dialog.destroy();
			}
		}
	});

	api.errorEmitter.on("oneSalePerOrder", function (e, msg) {
		var popup = app.dialog.decisionPopup({
			message: msg,
			buttons: [
				{ 'data-role': 'goToBasket', text: PageTemplates.get('js_Checkout'), 'class': 'MiddleButton custom-dialog-go-to-basket' },
				{ 'data-role': 'clearBasket', text: PageTemplates.get('js_ClearBasket'), 'class': 'MiddleButton custom-dialog-clear-basket' }
			]
		});
		popup.on('click:goToBasket', function () { window.location = app.globalUrls.checkout; });
		popup.on('click:clearBasket', function () {
			api.clearOrder().done(function () {
				popup.destroy();
				window.location.reload();
			});
		});
	});

	api.errorEmitter.on('saleNotActive', function (e, msg) {
		app.dialog.decisionPopup({
			message: msg,
			buttons: [{ 'data-role': 'ok', text: PageTemplates.get('_Ok'), 'class': 'MiddleButton MiddleButton__center' }]
		}).on('click:ok', function () {
			var defaultPage = window.location.href.toLowerCase().indexOf('default') > -1 || window.location.pathname === '/';
			if (defaultPage) this.destroy();
			else window.location = app.globalUrls.shop;
		});
	});

	api.errorEmitter.on('addToBasketError', function (e, msg) {
		app.dialog.error({
			title: '<div class="notifier-message__icon"><div class="warning-icon notifier-message_icons-title"></div>' + PageTemplates.get('_FailedToAdd') + '</div>',
			message: '<div class="notifier-message__icon">' + msg + '</div>'
		});
	});

	api.errorEmitter.on('loginFailed', function (e, msg, hideErrors) {
		if (!hideErrors) {
			app.dialog.error({
				title: '<div class="notifier-message__icon"><div class="warning-icon notifier-message_icons-title"></div>' + PageTemplates.get('_LoginFailed') + '</div>',
				message: '<div class="notifier-message__icon">' + msg + '</div>'
			});
		}
	});

	api.errorEmitter.on('registrationFailed', function (e, msg) {
		app.dialog.error({
			title: '<div class="notifier-message__icon"><div class="warning-icon notifier-message_icons-title"></div>' + PageTemplates.get('_RegistrationNotCompleted') + '</div>',
			message: '<div class="notifier-message__icon">' + msg + '</div>'
		});
	});

	api.errorEmitter.on('timeout', function () {
		app.dialog.error({
			title: '<div class="notifier-message__icon"><div class="warning-icon notifier-message_icons-title"></div>' + PageTemplates.get('_ServerError') + '</div>',
			message: '<div class="notifier-message__icon">' + PageTemplates.get('mobile_serverErrorMessage') + '</div>'
		});
	});

	api.errorEmitter.on('unknown', function () {
		window.location.assign('error.aspx');
	});

	var logoutXhr;
	api.errorEmitter.on('unauthorized', function () {
		if (!logoutXhr) {
			api.errorEmitter.trigger('abortAll');
			logoutXhr = api.logout().done(function () {
				if (app.landingForm && app.GlobalSettings.Upffa) {
					app.landingForm.showPopup({ closeBtn: true }).done(function () {
						location.reload();
					}).fail(function () {
						window.location = globalUrls.returnUrl;
					});
				} else {
					window.location.assign('login.aspx?ReturnUrl=' + encodeURIComponent(window.location.pathname + window.location.search));
				}
			}).always(function () {
				logoutXhr = null;
			});
		}
	});

    var setting = app.cookie.getUserSettings();
	if (($.isEmptyObject(setting) || !app.cookie.get('xt')) && !window.location.href.match(/error.aspx/gi)) {

		var now = new Date();
		var utc = now.getTime() + now.getTimezoneOffset() * 60000;
		api.getUserCookiesXt({ clientTime: new Date(utc).format() }, { async: false }).done(function () {
            setting = app.cookie.getUserSettings();
			$.extend(app.GlobalSettings, setting);
			app.GlobalSettings.XT = parseInt(app.cookie.get('xt')) || 0;
			api.userGroup = app.GlobalSettings.ug;
		});
	}
})(API, app);